'use client'; // This directive is required for client-side code in the app directory

import { LandingPage } from '@/components/landing-page';

export default function HomePage() {
  return <LandingPage />;
}
